(function() {
	angular.module('ShargoApp')
		.controller('EnterpriseContactController', function ($scope, $rootScope, $route, $filter, $http, Configuration, Analytics) {
			$scope.shargoPro = $route.current.$$route.shargoPro;
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: -1000,
					background: $scope.shargoPro ? 'linear-gradient(to bottom, #585757, #4a4a4a)' : 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $scope.shargoPro ? $rootScope.url('shargopro-page') : $rootScope.url('home'),
					headerLogo: $scope.shargoPro ? ($rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargopro-white.svg" : Configuration.siteDomain + "/img/header/shargopro-mobile.svg") : ($rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg"),
					logIn: false,
					dashboard: false,
					callToAction: {
						link: false,
						text: '',
						target: '_self',
						hide: false,
						disabled: false
					},
					profile: false
				}
			};

			$scope.form = {
				enterprise: "",
				name: "",
				email: "",
				phone: "",
				message: "",
				error: {}
			};
			$scope.selector = {
				sectors: false,
				packages: false
			};
			$scope.sectors = ['enterprise-contact.sector.title', 'enterprise-contact.sector.1', 'enterprise-contact.sector.2', 'enterprise-contact.sector.3', 'enterprise-contact.sector.4', 'enterprise-contact.sector.5', 'enterprise-contact.sector.6', 'enterprise-contact.sector.7', 'enterprise-contact.sector.8', 'enterprise-contact.sector.9'];
			$scope.packages = ['enterprise-contact.packages.title', 'enterprise-contact.packages.1', 'enterprise-contact.packages.2', 'enterprise-contact.packages.3', 'enterprise-contact.packages.4'];
			$scope.uploadingForm = false;

			var validPhone = "";
			$scope.checkPhone = function (){
				if(!/^[0-9]*$/.test($scope.form.phone)) {
					$scope.form.phone = validPhone;
				}
				else {
					validPhone = $scope.form.phone;
				}
			};

			$scope.selectItem = function (index, array) {
				$scope.selector[array] = !$scope.selector[array];

				var aux = $scope[array][0];
				$scope[array][0] = $scope[array][index];
				$scope[array][index] = aux;

				if ((aux === "enterprise-contact.sector.title" || aux === "enterprise-contact.packages.title") && !$scope.selector[array]){
					$scope[array].splice(index, 1);
				}
			};

			$scope.sendEmail = function (email) {
				console.log("SENDING EMAIL", email);
				if ($scope.form.name && $scope.form.enterprise && $scope.form.phone.length == 9 && $scope.form.message && email.$valid) {
					$scope.uploadingForm = true;
					var params = {
						businessName: $scope.form.enterprise,
						name: $scope.form.name,
						email: $scope.form.email,
						phone: $scope.form.phone,
						sector: $scope.sectors[0] !== "enterprise-contact.sector.title" ? $filter('translate')($scope.sectors[0]) : 'nodefined',
						numPackages: $scope.packages[0] !== "enterprise-contact.packages.title" ? $filter('translate')($scope.packages[0]) : 'nodefined',
						body: $scope.form.message
					};
					console.log("SEND FORM", params);
					Analytics.trackEvent('formulario', 'click', 'conversion', 11);
					$http.post(Configuration.apiUrl + '/apiContactEmail', params)
						.then(function successCallback(response) {
							console.log("SUCCESS", response);
							$scope.form.send = true;
							$scope.uploadingForm = false;
						}, function errorCallback(data) {
							console.log("ERROR", data);
							$scope.uploadingForm = false;
						});
				}
				else {
					if (!$scope.form.enterprise) {
						$scope.form.error.enterprise = 'enterprise-contact.error.enterprise';
					}
					if (!$scope.form.name) {
						$scope.form.error.name = 'enterprise-contact.error.name';
					}
					if ($scope.form.phone.length != 9) {
						$scope.form.error.phone = 'enterprise-contact.error.phone';
					}
					if (!$scope.form.message) {
						$scope.form.error.message = 'enterprise-contact.error.message';
					}
					if (!email.$valid) {
						$scope.form.error.email = 'enterprise-contact.error.email';
					}
				}
			};
		});
})();
